<template>
    <div class="main bbt-main--margin bbt-main">
        <div class="bbt-container">
            <div class="bbt-row" style="margin-left: -12px; margin-right: -12px;">
                <div class="bbt-col-xs-16" style="padding-left: 12px; padding-right: 12px; position: relative;">
                    <div class="bbt-tab bbt-tab--lg">
                        <ul class="bbt-tab__menu bbt-clearfix">
                            <li class="active" @click="transActiveLine">
                            7*24h 快讯
                            </li>
                            <!-- <li class="" @click="transActiveLine">
                            大事件
                            </li> -->
                        </ul>
                        <div class="li-active__line" style="left: 0px; width: 106px; opacity: 1;"></div>
                    </div>
                    <!-- <div class="bbt-subtab bbt-clearfix">
                        <span class="label">热门话题</span>
                        <ul class="bbt-subtab__menu bbt-clearfix">
                            <li class="">
                            比特币
                            </li>
                            <li class="">
                            以太坊
                            </li>
                            <li class="">
                            比原链
                            </li>
                            <li class="">
                            EOS
                            </li>
                        </ul>
                    </div> -->
                    <div v-loading="articleLoad" class="flash-content">
                        <div>
                            <div class="flash-module">
                                <div class="flash-module__block">
                                    <div class="flash-module__lists">
                                        <div class="line"></div>
                                        <div class="flash-wrap">
                                            <ul class="flash-list">
                                                <li class="flash-item" v-for="item in articleNews" :key="item.id">
                                                    <div class="flash-item__body">
                                                        <span class="flash-item__time"></span>
                                                        <router-link :to="{path:'/articleDetail/' + item.id}" class="flash-item__title" target="_blank">
                                                        【<span>{{item.title}}</span>】
                                                        </router-link>
                                                        <div class="flash-item__content" v-html="item.content">
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="operate-box bbt-clearfix">
                                                        <!-- <span class="operate-item operate-item__up">
                                                            <i class="bbt-icon bbt-icon-rise" style="font-size: 12px;"></i>
                                                            利好 0
                                                            <i class="num">-1</i>
                                                        </span>
                                                        <span class="operate-item operate-item__down">
                                                            <i class="bbt-icon bbt-icon-fall" style="font-size: 12px;"></i>
                                                            利空 0
                                                            <i class="num">-1</i>
                                                        </span>
                                                        <div class="operate-item operate-item__img link-dark-minor">
                                                            <i class="bbt-icon bbt-icon-picture"></i> 生成图片
                                                        </div>
                                                        <div class="operate-item operate-item__share">
                                                            <div class="share-box">
                                                                <span><i class="bbt-icon bbt-icon-share" style="font-size: 16px;"></i>分享</span>
                                                            </div>
                                                        </div> -->
                                                        <span class="operate-item operate-item__source" v-if="item.updateTime != null">
                                                            {{ $filters.formatDate(item.updateTime) }}
                                                        </span>
                                                        <span class="operate-item operate-item__source" v-if="item.articleSource != ''">
                                                            来源：<a href="https://coinpost.jp/?p=105335" target="_blank" rel="nofollow noopener noreferrer" class="flash-item__link dark-minor">{{item.articleSource}}</a>
                                                        </span>
                                                        <span class="operate-item operate-item__source">
                                                            作者：<a href="https://coinpost.jp/?p=105335" target="_blank" rel="nofollow noopener noreferrer" class="flash-item__link dark-minor">{{item.author}}</a>
                                                        </span>
                                                    </div>
                                                </li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;">
                            <div class="bbt-col-xs-24" style="padding-left:12px;padding-right:12px;">
                                <div class="bbt-btn bbt-btn--default bbt-btn--lg bbt-btn-block" @click="loadMoreArticle" v-if="hasMoreArticle">
                                    查看更多
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bbt-col-xs-7 bbt-col-xs-offset-1" style="padding-left: 12px; padding-right: 12px;"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'MoreArticle',
    props:{
        serveHost: String
    },
    data() {
        return {
            articleLoad:false,
            hasMoreArticle:true,
            articleType:0,
            pagNo:1,
            APIS:[
                {
                    // 快讯列表
                    name:'articleNews',
                    url:'/api/v1/article/getFlashArticle'
                }
            ],
            articleNews:[]
        }
    },
    methods:{
        transActiveLine:function(event) {
            // 图书栏目/文章类别切换
            var _vm = this;
            var l_offset = event.target.offsetLeft;
            var w_offset = event.target.offsetWidth;
            // 类型
            let eventType = event.target.dataset.type;
            $(event.target).parent().siblings('.li-active__line').css({left:l_offset});
            $(event.target).parent().siblings('.li-active__line').width(w_offset);
            $(event.target).attr('class', 'active').siblings().removeAttr('class');
            _vm.articleType = event.target.dataset.cid;
            _vm.hasMoreArticle = false;
            _vm.articleLoad = true;
            _vm.loadArticleList(_vm, 1, _vm.articleType);
            setTimeout(function(){
                _vm.articleLoad = false;
            },2000)
        },
        loadArticleList:function(_vm, pagNo, category) {
            if(category != '') {
                _vm.articleNews = [];
            }
            // 快讯
            this.loadDataByAsync(_vm.serveHost + "/api/v1/article/getFlashArticle", {
                pageNo: pagNo,
                category: category
            }, function(r){
                if(r.code != "2000000") {
                    console.error('get more article error.');
                    // return;
                }
                if(r.data) {
                    r.data.forEach((item, index) => {
                        _vm.articleNews.push(item);
                    });
                    _vm.articleLoad = false;
                    _vm.hasMoreArticle = true;
                } else {
                    _vm.hasMoreArticle = false;
                    _vm.$alert('没有更多的快讯了', '提示', {
                        type:'warning',
                        closeOnClickModal:true,
                        closeOnPressEscape:true,
                        confirmButtonText: '确定',
                        callback: action => {
                            
                        }
                    });
                }
            });
        },
        loadDataByAsync:function(URL, DATA, CALLBACK_FUNC) {
            $.get(URL, DATA, CALLBACK_FUNC);
        },
        loadMoreArticle:function() {
            // 快讯列表更多加载
            this.pagNo++
            this.loadArticleList(this, this.pagNo, this.articleType);
        }
    },
    created() {
        var _vm = this;
        this.APIS.forEach((item, index) => {
            _vm.loadDataByAsync(_vm.serveHost + item.url, function(r){
                if(r.code != "2000000") {
                    console.error('get '+ item.name +' error.');
                    return;
                }
                _vm[item.name] = r.data;
                console.log(r.data);
            });
        });
    }
}
</script>

<style scoped>
.bbt-btn.bbt-btn--default {
    color: rgba(0,0,0,.88);
    background: #f1f1f1;
    border-color: #f1f1f1;
    transition: all .3s ease;
}
.bbt-btn.bbt-btn--lg {
    font-size: 14px;
    padding: 12px 18px;
    border-radius: 4px;
}
.bbt-btn.bbt-btn-block {
    display: block;
    width: 100%;
}
.share-box {
    position: relative;
    font-size: 14px;
    line-height: 22px;
    cursor: pointer;
    transition: all .3s ease;
}
.share-box>span {
    display: inline-block;
}
.flash-item__link {
    color: rgba(0,0,0,.56);
    transition: all .3s ease;
}
.flash-item .operate-box .operate-item.operate-item__source {
    padding: 3px 0;
    margin-right: 8px;
    background: none;
    float: right;
    cursor: default;
}
.flash-item .operate-box .operate-item.operate-item__share {
    padding: 3px 8px;
    border-radius: 4px;
    background: none;
    float: right;
    color: rgba(0,0,0,.56);
    margin-right: 8px;
    transition: all .3s ease;
}
.flash-item .operate-box .operate-item.operate-item__img {
    float: right;
    background: none;
    padding: 3px 0;
}
.flash-item .operate-box .operate-item.operate-item__down, .flash-item .operate-box .operate-item.operate-item__up {
    border-radius: 4px;
    padding: 3px 8px;
}

.flash-item .operate-box .operate-item {
    font-size: 14px;
    line-height: 22px;
    background: #f1f1f1;
    color: rgba(0,0,0,.56);
    margin-right: 16px;
    float: left;
    cursor: pointer;
    transition: all .3s ease;
    position: relative;
}
.flash-item .operate-box {
    margin-top: 16px;
}
.flash-item__time:before {
    content: "";
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: #fff;
    border: 2px solid rgba(0,0,0,.56);
    margin-right: 8px;
    font-size: 12px;
    line-height: 19px;
    text-align: center;
    vertical-align: middle;
    margin-top: -3px;
}
.flash-item__content {
    display: inline;
}

.flash-item__content {
    word-break: break-all;
}
.flash-item__title {
    font-weight: 700;
    color: rgba(0,0,0,.88);
    transition: all .3s ease;
}
.flash-item__time {
    font-size: 14px;
    line-height: 22px;
    display: block;
    position: absolute;
    color: rgba(0,0,0,.56);
    left: -20px;
    top: 0;
    width: 80px;
}
.flash-item__body {
    color: rgba(0,0,0,.88);
    font-size: 16px;
    line-height: 24px;
    word-break: break-word;
    position: relative;
}
.flash-item {
    border-bottom: 1px dashed #d8d8d8;
    margin-bottom: 32px;
    padding-bottom: 24px;
}
.flash-list {
    margin: 0;
    list-style: none;
    padding-left: 20px;
}
.flash-module__lists .line {
    position: absolute;
    left: 3px;
    top: 36px;
    bottom: 72px;
    width: 0;
    border-left: 1px dashed #d8d8d8;
}
.flash-module__lists {
    padding: 30px 0 40px;
    position: relative;
}
.flash-content {
    position: relative;
}
.bbt-subtab__menu li {
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    color: rgba(0,0,0,.56);
    text-align: center;
    padding: 3px 12px;
    border: 1px solid rgba(0,0,0,.1);
    border-radius: 14px;
    margin-left: 16px;
    cursor: pointer;
    transition: all .3s ease;
}
.bbt-subtab__menu {
    padding-left: 84px;
    padding: 0;
    list-style-type: none;
}
.bbt-subtab .label {
    display: inline-block;
    font-size: 14px;
    color: rgba(0,0,0,.56);
    line-height: 26px;
    float: left;
    font-weight: 700;
}
.bbt-subtab {
    margin-top: 8px;
    margin-bottom: 24px;
}
.bbt-tab__menu>li+li {
    margin-left: 40px;
}
.bbt-tab.bbt-tab--lg .bbt-tab__menu>li {
    font-size: 20px;
    line-height: 28px;
    padding: 0;
    position: relative;
}

.bbt-tab__menu>li.active {
    color: rgba(0,0,0,.88);
}
.bbt-tab__menu>li {
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.56);
    padding: 7px 0;
    float: left;
    list-style: none;
    position: relative;
    font-weight: 700;
    transition: all .3s ease;
    cursor: pointer;
}
.bbt-tab.bbt-tab--lg .li-active__line {
    bottom: -6px;
}
.bbt-tab .li-active__line {
    height: 4px;
    position: absolute;
    left: 0;
    width: 40px;
    bottom: 2px;
    border-radius: 2px;
    background: #e00;
    transition: all .3s ease;
}
.bbt-tab__menu {
    position: relative;
}
.bbt-tab {
    position: relative;
    margin-bottom: 32px;
}
.bbt-col-xs-offset-1 {
    margin-left: 4.16666667%;
}
.bbt-col-xs-7 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 29.16666667%;
}
.bbt-col-xs-16 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66666667%;
}
.bbt-main--margin {
    padding-top: 32px;
}

.bbt-main {
    padding-bottom: 48px;
}
</style>